import React from "react";

const Footer = () => {
  return (
    <footer className="site-footer">
      <p>© Hassan Zahar Rifat</p>
      <p className="site-footer__tag">
        Built with React. Deployed where it makes sense.
      </p>
    </footer>
  );
};

export default Footer;
